<template>
  <div class="page">
    <page-title icon="#icon-appmanage" :title="pageTitle"/>
    <div class="limited-wrap warning-tip" v-if="isLimited">
      <p>尊敬的客户，</p>
      <p>为保障账号安全和风险控制，我们对用户创建应用的数量进行了限制；</p>
      <p>未认证用户只允许创建<span>1个</span>应用；<router-link to="/user/authentication/personal">个人实名认证</router-link>用户可创建<span>5个</span>应用，<router-link to="/user/authentication/company">企业实名认证</router-link>用户可创建<span>20</span>个应用；</p>
      <p><a target="_blank" :href="`${baseUrl}/doc/authentication/authentication.html`">了解开放平台用户认证须知 >></a></p>
    </div>
    <div v-else class="create-wrap">
      <el-form label-position="top" :model="form" :rules="rules" ref="form" label-width="1.25rem" class="demo-ruleForm">
          <el-form-item label="应用名称" prop="appName">
            <el-input size="large" v-model="form.appName" placeholder='请设定一个应用名称，少于30个字符' auto-complete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="应用分类" prop="appCategory" >
            <el-input size="large" v-model="form.appCategory"
              icon="caret-bottom"
              placeholder="应用分类标签最多选一个" 
              @click.native="isShowCategoryList=!isShowCategoryList"
              readonly>
            </el-input>
            <div>
              <category-select
                v-if="isShowCategoryList"
                :categoryList="categoryList"
                v-on:categoryChange="setCategary"
                v-on:hideCategoryList="hideCategoryList"
                >
              </category-select> 
            </div>
          </el-form-item>
          <el-form-item label="应用功能描述" prop="appDescr">
            <el-input size="large"  v-model="form.appDescr" type="textarea"
              :autosize="{ minRows: 4, maxRows: 8}" 
              placeholder="请简述使用场景、应用特点等信息，不超过1000个字符"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button size="large" type="primary" class="btn-submit" @click="submitForm('form')">提交</el-button>
            <router-link class="link-create" to="/app/myapp">
              <el-button
                type="text"
                size="large" >
                返回我的应用
              </el-button>
            </router-link>
          </el-form-item>
        </el-form>  
    </div>
  </div>
</template>
<script>
import CategorySelect from './CategorySelect'
import PageTitle from 'components/PageTitle'
import ajax from 'api/create'
import appAjax from 'api/my-app'
import { mixin as clickaway } from 'vue-clickaway'
import * as utils from 'libs/utils'
import { mapActions } from 'vuex'
export default {
  name: 'Create',
  components: {
    CategorySelect,
    PageTitle
  },
  mixins: [ clickaway ],
  data(){
    //自定义校验规则
    var validateAppName = (rule, value, callback) => {
      ajax.isAppNameExist(this.form).then(data => {
        if (!data.flag) {
          callback(new Error("应用名称已存在"));
        } else {
          callback()
        }
      })
    } 

    var validateAccept = (rule, value, callback) => {
      if(!value){
        callback(new Error("请接受用户服务协议，谢谢"))
      }else{
        callback()
      }
    } 
    //自定义校验规则end
    return {
      isLimited: false,
      platformList:[],//平台列表
      categoryList:[],//分类列表
      isShowCategoryList:false,
      platformDisable:false,
      form: {
        appName: '',
	      appOs: '',
	      appCategory: '',
	      appDescr: '',
	      accept: true
      },
      rules: {
        appName: [
          { required: true, message: '请填写应用名称', trigger: 'blur' },
          { max: 30, message: '应用名称长度小于30个字符', trigger: 'blur' },
          { validator: validateAppName,  trigger: 'blur' } ,
          { pattern: /^[a-zA-Z0-9-._\u4e00-\u9fa5]{1,}$/, message: '不可包含中英文、数字、下划线、点及连字符以外的字符', trigger: 'change,blur' },
          { max: 30, message: '应用名称长度小于30个字符', trigger: 'change' },
        ],
        appCategory: [
          { required: true, message: "请选择应用分类", trigger: 'blur' }
        ],
        appDescr: [
          { required: true, message: "请简述使用场景、应用特点等信息，不超过1000个字符", trigger: 'blur' },
          { max: 1000, message: '应用描述不超过1000个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    baseUrl(){
      return Url[Mode].baseUrl
    },
    pageTitle() {
      return [{ name: '我的应用' }, { name: '创建应用' }]
    }
  },
  created () {
    ajax.getLimit().then(d =>{
      if(d.code === 10013){
        this.isLimited = true
      }
    })
    // 初始化分类
    ajax.getCategory().then(data => {
      if (data.flag) { 
        this.categoryList = data.data
      } else {
        this.$message.error('分类列表获取失败:'+data.desc)
      }
    })
  },
  methods: {
    ...mapActions([
      'setAppId'
    ]),
    hideCategoryList(){
      this.isShowCategoryList=false
    },
    setCategary(v){
      this.form.appCategory = v
      this.isShowCategoryList=false
      this.$refs.form.validateField('appCategory')
    },
    checkAccept(){
      this.$refs.form.validateField('accept')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = utils.copy(this.form)
          params["accept"] = params["accept"] ? 1 : 0
          params["registerFrom"]= 'city_shandong'
          ajax.create(params).then(res => {
            if (res.flag) {
              // 如果路由中有跳转信息，表示是第一个应用，默认设置为默认应用，并跳转至指定路由
              if (this.$route.query.redirect) {
                // 如果redirect是/sale/buy则带参回跳至下单页
                if (this.$route.query.redirect === '/sale/buy') {
                  this.$message({
                    message: '创建成功',
                    type: 'success'
                  })
                  this.$router.push({
                    path: this.$route.query.redirect,
                    query: {
                      businessId: this.$route.query.businessId,
                      wareId: this.$route.query.wareId,
                      appId: res.data,
                      appName: this.form.appName,
                      serviceName: this.$route.query.serviceName,
                      packageId: this.$route.query.packageId
                    }
                  })
                } else {
                  appAjax.setDefaultApp(res.data).then(r => {
                    if (r.code === 0 || r.code === '0') {
                      this.setAppId(res.data)
                      this.$message({
                        message: '创建成功',
                        type: 'success'
                      })
                      this.$router.push({
                        path: this.$route.query.redirect
                      })
                    } else {
                      this.$message.error('切换应用失败:' + r.desc)
                      this.$router.push({
                        path: '/app/myapp'
                      })
                    }
                  }).catch(errMsg => {
                    this.$message.error('切换应用失败:' + errMsg)
                  })
                }
              } else {
                this.$router.push({
                  path: '/app/myapp'
                })
                this.$message({
                  message: '创建成功',
                  type: 'success'
                })
              }
            } else {
              this.$message.error('创建失败:'+data.desc);
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>
<style lang="stylus">
@import '~styl/mixins'
pageBase()
.limited-wrap
  margin-top .6rem
  padding .6rem 0.15rem
  p
    line-height .3rem
    a 
      color: color-light-blue;
  
.create-wrap
  width 100%
  max-width 10rem
  padding: .6rem 0.15rem
  .el-input--large {
    font-size: 14px;
  }
  .el-select
    width: 100%
  .el-checkbox
    line-height: .16rem
    a
      color: color-blue
  .el-button
    width: 1.6rem
    margin-top: 0

warning-tip()

</style>
<style lang="stylus">
.create-wrap 
  .el-checkbox__inner
    z-index: unset
</style>



// WEBPACK FOOTER //
// app/components/Dashboard/App/Create/Main.vue